import { BaseModal, ModalCloseCross, type BaseModalProps } from "@/components/modals/BaseModal";
import { sendAjaxRequest } from "@/ts/api/comunicacion";

export function ModalCicloNotificacion(props: BaseModalProps) {
	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h4 className="modal-title">ALERTA</h4>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body">
				<div className="content-box big-box">
					<div className="table-responsive">
						<div style={{ textAlign: "center" }} id="divNuevosCiclos">
							<a target="_self" className="btnIcon">
								<span className="iconify iconoalerta" data-icon="ant-design:warning-filled" data-inline="false" />
							</a>
						</div>
					</div>
				</div>
				<div className="modal-footer" style={{ textAlign: "center" }}>
					<button type="button" className="btnSecondary" onClick={props.close}>Cerrar</button>
				</div>
			</div>
		</BaseModal>
	);
}

async function consultarNuevosCiclosJefeFabrica(): Promise<void> {
	// if ($("#modalCicloNotificacion").hasClass("in")) {	//modal esta abierto, no consulto
	// 	return;
	// }

	const parametro = {};
	const url = "/api/v1/getNuevosCiclosJefeFabrica";
	const response = await sendAjaxRequest<string[]>("GET", url, parametro);

	if (response.length > 0) {
		// await getArticulosCiclos();
		// await updateComboCiclos();
		// response.forEach((xnumhoja_id) => {
		// 	const xaccion = $("#plantillaNotificacionNuevoCiclo").clone();
		// 	xaccion.removeAttr("id");
		// 	xaccion.find("span").text(xnumhoja_id);
		// 	xaccion.addClass("notificacionNuevoCiclo");
		// 	$("#divNuevosCiclos").prepend(xaccion);
		// });

		// $("#modalCicloNotificacion").modal("show");
	}
}